import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { useEffect, useState } from 'react';
import devLogger from 'react-utils/devLogger';
import { getSource } from 'ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import ActivationModalContainer from '../_core/common/components/activation/ActivationModalContainer';
import { productActivationApiNames, productActivationProducts } from '../_core/common/constants/productActivation';
import { sourceKeys } from '../_core/common/data/upgradeData/properties/sources';
import { activateProduct } from '../_core/productActivation/activateProduct';
import { ACTIVATE } from '../_core/purchaseMotions/PurchaseMotionTypes';
import { trackPurchaseMotionFailure } from '../_core/utils/metricUtils';
import { navigateTo } from '../_core/common/navigation/url';
import { getWebsitesUrl } from '../_core/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIProductActivationButton = ({
  upgradeData,
  use
}) => {
  const [showProductActivationModal, setShowProductActivationModal] = useState(false);
  const [hasActivationError, setHasActivationError] = useState(false);
  const isValidProductActivationProduct = upgradeData.apiName ? productActivationApiNames.includes(upgradeData.apiName) : productActivationProducts.includes(upgradeData.upgradeProduct);
  const source = getSource({
    app: upgradeData.app,
    screen: upgradeData.screen,
    uniqueId: upgradeData.uniqueId
  }, sourceKeys.PRODUCT_ACTIVATION);
  useEffect(() => {
    if (isValidProductActivationProduct) {
      tracker.track('productActivationButtonInteraction', Object.assign({
        action: 'viewed'
      }, getUpgradeDataTrackingProperties(upgradeData), {
        source
      }));
    }
  }, [upgradeData, isValidProductActivationProduct, source]);
  const handleSuccess = () => navigateTo(getWebsitesUrl());
  const handleClick = () => {
    tracker.track('productActivationButtonInteraction', Object.assign({
      action: 'clicked'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      source
    }));
    activateProduct(upgradeData).then(() => setShowProductActivationModal(true)).catch(() => {
      trackPurchaseMotionFailure({
        uniqueId: upgradeData.uniqueId,
        apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct],
        purchaseMotion: ACTIVATE
      });
      setShowProductActivationModal(true);
      setHasActivationError(true);
    });
  };
  if (!isValidProductActivationProduct) {
    devLogger.warn({
      message: `ProductActivationWrapper: Expected upgradeProduct to be one of ${productActivationProducts}`,
      key: 'ProductActivationWrapper'
    });
    return null;
  }
  const buildI18nKey = () => {
    if (upgradeData.apiName) {
      return `upgrades.productActivationButton.${upgradeData.apiName}`;
    }
    return `upgrades.productActivationButton.${upgradeData.upgradeProduct}`;
  };
  const key = buildI18nKey();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showProductActivationModal && /*#__PURE__*/_jsx(ActivationModalContainer, {
      type: sourceKeys.PRODUCT_ACTIVATION,
      onSuccess: handleSuccess,
      hasError: hasActivationError,
      upgradeData: upgradeData
    }), /*#__PURE__*/_jsx(UIButton, {
      use: use,
      onClick: handleClick,
      "data-test-id": "product-activation-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: key
      })
    })]
  });
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIProductActivationButton.defaultProps = {
  use: 'primary'
};
export default UIProductActivationButton;